const isValidatedDate = (selectedDate, comparedDate, setFormState, name) => {
  console.log(selectedDate, "selectedDate");
  console.log(comparedDate, "comparedDate");
  name = name?.split('"').join(" ");

  if (selectedDate > comparedDate) {
    setFormState((formState) => ({
      ...formState,
      [name]: selectedDate,
    }));
  } else {
    setFormState((formState) => ({
      ...formState,
      [name]: " ",
    }));
  }
};
export default isValidatedDate;
